
import { onMounted, ref, shallowRef, watch } from '@vue/composition-api';
import type { BonusCard } from '~/type/BonusCard';
const __sfc_main = {};
__sfc_main.props = {
  data: {
    key: "data",
    required: false,
    type: null
  },
  showCode: {
    key: "showCode",
    required: false,
    type: Boolean,
    default: true
  },
  height: {
    key: "height",
    required: false,
    type: String
  },
  animationBalance: {
    key: "animationBalance",
    required: false,
    type: Boolean,
    default: false
  },
  userAuth: {
    key: "userAuth",
    required: true,
    type: Boolean
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  // const emit = defineEmits<{
  //   (e: 'show-modal'): void
  // }>()

  const isShareButtonHover = ref(false);
  const icon = shallowRef<HTMLElement>();
  // const isAnimated = ref(false)

  // function onMouseOver() {
  //   isShareButtonHover.value = true
  //   if (!isAnimated.value) {
  //     icon.value?.classList.add('bonus-card__icon-image_hover-animate')
  //     isAnimated.value = true
  //   }
  // }

  const animationDurationBalance = ref(2000);
  const balance = ref(0);
  watch(() => props.data?.balance, () => {
    if (props.animationBalance) increaseBalanceCounter(props.data?.balance);else balance.value = props.data?.balance || 0;
  });
  onMounted(() => {
    if (props.animationBalance) increaseBalanceCounter(props.data?.balance);else balance.value = props.data?.balance || 0;
    icon.value?.classList.add('bonus-card__icon-image_animate');
  });
  function increaseBalanceCounter(balanceCount = 0) {
    const frameRate = 16.67; // Интервал времени между кадрами в миллисекундах

    const increment = balanceCount / animationDurationBalance.value * frameRate;
    function animate() {
      if (balance.value < balanceCount) {
        balance.value += increment;
        window.requestAnimationFrame(animate);
      } else {
        balance.value = balanceCount;
      }
    }
    window.requestAnimationFrame(animate);
  }
  return {
    props,
    isShareButtonHover,
    balance
  };
};
export default __sfc_main;
